import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useCustomerAuth } from "../contexts/CustomerAuthContext";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useCustomerAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/api/customer/auth/google-session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error("Auth failed");
        const data = await res.json();
        login(
          { customer_id: data.customer_id, email: data.email, name: data.name, picture: data.picture },
          data.session_token
        );
        // CHANGED: Check if there's a pending look save from before login
        const pendingLook = sessionStorage.getItem("mahra_pending_save_look");
        if (pendingLook) {
          navigate("/build-your-look", { replace: true });
        } else {
          navigate("/account", { replace: true });
        }
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#FAF8F0] flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-[#9A7B4F]" />
    </div>
  );
}
